import { FC } from "react";
import { Box, Text } from "@chakra-ui/react";

import { SbpTransferPageTerm } from "./SbpTransferPageTerm";
import { SbpTransferPageAmount } from "./SbpTransferPageAmount";

export const SbpTransferPageAmountAndTerm: FC = () => {
  return (
    <Box bg="white" borderRadius="16px" p="20px">
      <Text mt="1px" mb="8px" fontSize="12.5px" lineHeight="1">Сумма перевода</Text>

      <SbpTransferPageAmount />
      <SbpTransferPageTerm />
    </Box>
  );
};
